import type { TreeNodeData } from "../types";

export const getParentKey = (
  key: string,
  tree: TreeNodeData[]
): string | undefined => {
  for (const node of tree) {
    if (node.children) {
      if (node.children.some(child => child.key === key)) return node.key;
      const parentKey = getParentKey(key, node.children);
      if (parentKey) return parentKey;
    }
  }

  return undefined;
};

export const flattenTreeData = (
  tree: TreeNodeData[]
): { key: string; title: string }[] => {
  const list: { key: string; title: string }[] = [];
  const walk = (nodes: TreeNodeData[]) => {
    nodes.forEach(node => {
      if (typeof node.title === "string") {
        list.push({ key: node.key, title: node.title });
      }
      if (node.children) walk(node.children);
    });
  };
  walk(tree);

  return list;
};

export const getExpandedKeysFromSearch = (
  searchValue: string,
  treeData: TreeNodeData[],
  dataList: { key: string; title: string }[]
): string[] =>
  dataList
    .filter(item =>
      item.title.toLowerCase().includes(searchValue.toLowerCase())
    )
    .map(item => getParentKey(item.key, treeData))
    .filter((key, i, self): key is string => !!key && self.indexOf(key) === i);
